<template>
    <div>
        <el-form-item prop="name" :label="field.name + '：'" label-width="110px">
            <el-radio-group v-model="config[field.key]" @change="change" style="padding-top: 10px;">
                <span v-for="item in field['radio-list']" class="radio-item">
                    <el-radio class="radio" :label="item.value">{{item.label}}</el-radio>
                </span>
            </el-radio-group>
        </el-form-item>
    </div>
</template>

<style lang="scss" scoped>
    .radio-item {
        padding-right: 20px;
        .radio {
            margin-bottom: 10px;
        }
    }
</style>

<script>

  export default {
    name: 'tms-type-radio-box',
    props: {
      field: {
        type: [Object, Array],
        required: true
      },
      source: {
        type: String,
      }
      // config: {
      //   type: Object,
      //   default() {
      //     return {}
      //   }
      // }
    },
    data() {
      return {
        radio: 1
      }
    },
    computed: {
      config() {
        if (this.source === 'tmsPageConfig') {
          return this.$store.state.tms.pageData
        }
        if (this.source === 'tmsModuleConfig') {
          return this.$store.state.tms.config;
        }
        return this.$store.state.tms.customConfig;
      }
    },
    components: {},

    mounted() {
      if (!this.config[this.field.key]) {
        this.$set(this.config, this.field.key, 0);
      }

    },

    methods: {
      change(val) {
        this.config[this.field.key] = val;
      }
    }
  }

</script>
